export default "__VITE_ASSET__70piVIJK__"